import { sm2 } from 'sm-crypto'
export const validateIdCard = idCard => {
  // 基础格式校验
  const reg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
  if (!reg.test(idCard)) {
    return false;
  }
  // 校验码验证
  const factors = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
  const checksums = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
  let sum = 0;
  for (let i = 0; i < 17; i++) {
    sum += parseInt(idCard[i]) * factors[i];
  }
  const remainder = sum % 11;
  const expectedChecksum = checksums[remainder];
  return idCard[17].toUpperCase() === expectedChecksum;
};

/**
 * @description: 日期转字符串
 * @param {Date} time 日期 默认当前日期
 * @param {String} format 格式
 * @return {*}
 * @author: gumingchen
 */
export const parseDate2Str = (time = new Date(), format = '{y}-{M}-{d} {h}:{m}:{s}') => {
  if (!time) return ''
  let result = ''
  let date = new Date()
  const type = typeof time
  if (type === 'object') {
    date = time
  } else if (type === 'number') {
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    M: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    m: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  result = format.replace(/\{[yMdhmsa]+\}/g, (val) => {
    const key = val.replace(/\{|\}/g, '')
    const value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return result
}

// sm2 加密
export const rsaPublicData = function (data) {
  const publicKey = sessionStorage.getItem('2KCG')
  if (!data) return
  const cipherMode = 0
  const result = sm2.doEncrypt(data, publicKey, cipherMode)
  return result
}
